// src/pages/goodsReceivedNote/GoodsReceivedNoteA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';
import A4ProductCell from '../../components/common/A4DocumentLayout/A4ProductCell';

const itemName = (item) => {
  const product = item.purchaseOrderItem?.Product;
  const variation = item.purchaseOrderItem?.ProductVariation;
  if (!product) return `Item #${item.purchaseOrderItemId}`;
  return `${product.name}${variation?.sku ? ` — ${variation.sku}` : ''}`;
};

const GoodsReceivedNoteA4Document = ({ grn, purchaseOrder }) => {
  const { t } = useLocalization();

  if (!grn) return null;

  return (
    <A4DocumentLayout
      title={t('goodsReceivedNote.grnNumber')}
      subtitle={t('goodsReceivedNote.goodsReceivedNoteDetails')}
      documentNumber={`#${grn.grnNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(grn.createdAt).toLocaleString() },
        { label: t('common.status'), value: (grn.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('goodsReceivedNote.purchaseOrderNumber'),
          primary: `#${grn.purchaseOrder?.purchaseOrderNumber || t('common.na')}`,
          lines: [
            `${t('goodsReceivedNote.supplier')}: ${purchaseOrder?.Supplier?.name || t('common.na')}`,
            `${t('goodsReceivedNote.receivedAt')}: ${grn.receivedAt ? new Date(grn.receivedAt).toLocaleString() : t('common.na')}`,
            ...(grn.supplierDeliveryReference
              ? [`${t('goodsReceivedNote.supplierDeliveryReference')}: ${grn.supplierDeliveryReference}`]
              : []),
          ],
        },
        {
          title: t('goodsReceivedNote.warehouse'),
          lines: [grn.Warehouse?.name || t('common.na')],
        },
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('goodsReceivedNote.item') },
          { header: t('goodsReceivedNote.quantityReceived'), align: 'center' },
        ],
        rows: (grn.items || []).map((item, index) => [
          index + 1,
          <A4ProductCell
            item={item.purchaseOrderItem}
            name={item.purchaseOrderItem?.Product?.name || itemName(item)}
            sku={item.purchaseOrderItem?.ProductVariation?.sku || item.purchaseOrderItem?.Product?.sku}
          />,
          item.quantityReceived,
        ]),
      }}
      summary={grn.notes ? { notes: { label: t('goodsReceivedNote.notes'), text: grn.notes } } : undefined}
      footerNote="This is a computer-generated goods received note."
    />
  );
};

export default GoodsReceivedNoteA4Document;
